module.exports = __webpack_public_path__ + "static/media/sointu4logo.88359ed7.png";